import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["description", "name", "providerName", "certified", "imageSrcBig", "imageSrcSmall", "linkMode", "listingHref", "badgesSlot", "onLinkClick", "ribbonSlot"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { AgentIconWithFallback } from 'ai-components-ui-library/components/icons/AgentIconWithFallback';
import { HubspotCertificationIcon } from 'foundations-assets/icons/components/HubspotCertificationIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import styled from 'foundations-theming/utils';
import { useLazyImage } from '../LazyImageProvider';
import { PolymorphicLink } from '../PolymorphicLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUnderlineOnHover = styled.div.withConfig({
  displayName: "EcosystemCardLarge__StyledUnderlineOnHover",
  componentId: "sc-1pj1cyl-0"
})(["&:hover{text-decoration:underline;}"]);
export function EcosystemCardLarge(_ref) {
  let {
      description,
      name,
      providerName,
      certified = false,
      imageSrcBig,
      imageSrcSmall,
      linkMode = 'default',
      listingHref,
      badgesSlot,
      onLinkClick,
      ribbonSlot
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const lazyImage = useLazyImage();
  const linkProps = {
    href: listingHref,
    linkMode,
    onClick: onLinkClick,
    use: 'unstyled'
  };
  return /*#__PURE__*/_jsxs(CardWrapper, Object.assign({
    compact: true
    // this is set to "ecosystem-app-card" to make for easy migration off our legacy components
    ,
    "data-test-id": "ecosystem-app-card"
  }, props, {
    children: [ribbonSlot, /*#__PURE__*/_jsxs(CardSection, {
      children: [/*#__PURE__*/_jsx(PolymorphicLink, Object.assign({}, linkProps, {
        tabIndex: -1,
        "aria-hidden": true,
        children: /*#__PURE__*/_jsxs(View, {
          backgroundColor: "fill-surface-recessed",
          blockSize: "150px",
          borderRadius: "200",
          marginBlockEnd: "500",
          overflow: "hidden",
          position: "relative",
          children: [imageSrcBig && /*#__PURE__*/_jsx(Image, {
            blockSize: "150px",
            inlineSize: "100%",
            loading: lazyImage,
            objectFit: "cover",
            src: imageSrcBig
          }), !imageSrcBig && /*#__PURE__*/_jsx(Flex, {
            alignItems: "center",
            inset: "0",
            justifyContent: "center",
            position: "absolute",
            children: /*#__PURE__*/_jsx(AgentIconWithFallback, {
              iconUrl: imageSrcSmall,
              loading: lazyImage,
              marginBlockEnd: "0",
              name: name,
              size: 90
            })
          })]
        })
      })), certified && /*#__PURE__*/_jsx(View, {
        insetBlockStart: "600",
        insetInlineEnd: "600",
        padding: "200",
        position: "absolute",
        children: /*#__PURE__*/_jsx(Tooltip, {
          title: unescapedText('trellisEcosystem.appCard.certified'),
          children: /*#__PURE__*/_jsx(HubspotCertificationIcon, {
            "aria-label": unescapedText('trellisEcosystem.appCard.certified'),
            color: "fill-brand-default",
            size: "600"
          })
        })
      }), /*#__PURE__*/_jsx(PolymorphicLink, Object.assign({}, linkProps, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "h4",
          typography: "heading-100",
          overflowWrap: "break-word",
          children: /*#__PURE__*/_jsx(StyledUnderlineOnHover, {
            children: name
          })
        })
      })), /*#__PURE__*/_jsx(PolymorphicLink, Object.assign({}, linkProps, {
        tabIndex: -1,
        children: /*#__PURE__*/_jsx(Text, {
          as: "small",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "trellisEcosystem.appCard.providerName",
            options: {
              providerName
            }
          })
        })
      })), /*#__PURE__*/_jsx(PolymorphicLink, Object.assign({}, linkProps, {
        tabIndex: -1,
        children: /*#__PURE__*/_jsx(Text, {
          marginBlockStart: "200",
          marginBlockEnd: "400",
          children: description
        })
      })), /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        gap: "200",
        marginBlockStart: "auto",
        children: badgesSlot
      })]
    })]
  }));
}